import '../../styles/Loading/loading.css'
import logo from '../../assets/images/logo_single.png'


export class DPULoading {
    private _idContainer: string
    private _idLoader: string = ""
    constructor(idContainer: string) {
        this._idContainer = idContainer
        this._createLoading()
    }
    private _createLoading = () => {
        const containerView = document.querySelector(`#${this._idContainer}`)
        if (!containerView) return
        const spinner = document.createElement("div");
        spinner.classList.add("dpu-loader");
        spinner.id = "dpu-spinner";

        spinner.innerHTML = `
            <img class="dpu-logo" src="${logo}">
        `;
        this._idLoader = spinner.id
        containerView!.appendChild(spinner);
    }

    destroyLogo = () => {
        const containerView = document.querySelector(`#${this._idContainer}`)
        const idLoader = containerView!.querySelector(`#${this._idLoader}`)
        if (idLoader) {
            idLoader!.remove()
        }
    }
}